(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sf-hero"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('shub-hero-slider'))customElements.define('shub-hero-slider',class extends HTMLElement{
connectedCallback(){this.controller=new AbortController();const signal=this.controller.signal;this.track=this.querySelector('.shub-slider-track');this.slides=[...this.track.children];this.dots=[...this.querySelectorAll('[data-slide]')];this.index=0;this.paused=this.dataset.autoplay!=='true'||matchMedia('(prefers-reduced-motion: reduce)').matches;this.querySelector('.shub-slider-controls').hidden=this.slides.length<2;this.addEventListener('click',e=>{const b=e.target.closest('button');if(!b)return;if(b.hasAttribute('data-pause')){this.paused=!this.paused;this.sync();return}this.paused=true;if(b.hasAttribute('data-slide'))this.go(Number(b.dataset.slide));if(b.hasAttribute('data-direction'))this.go(this.index+Number(b.dataset.direction));this.sync()},{signal});this.track.addEventListener('scroll',()=>{this.index=Math.round(this.track.scrollLeft/this.track.clientWidth);this.dots.forEach((d,i)=>d.setAttribute('aria-current',String(i===this.index)))},{signal,passive:true});this.track.addEventListener('pointerdown',()=>{this.paused=true;this.sync()},{signal});this.track.addEventListener('keydown',e=>{if(e.key==='ArrowRight'||e.key==='ArrowLeft'){e.preventDefault();this.paused=true;this.go(this.index+(e.key==='ArrowRight'?1:-1));this.sync()}},{signal});this.addEventListener('mouseenter',()=>this.hovered=true,{signal});this.addEventListener('mouseleave',()=>this.hovered=false,{signal});this.addEventListener('focusin',()=>{this.paused=true;this.sync()},{signal});this.sync();this.timer=setInterval(()=>{if(!this.paused&&!this.hovered&&!document.hidden)this.go(this.index+1)},Number(this.dataset.interval)||6000)}
go(index){this.index=(index+this.slides.length)%this.slides.length;this.track.scrollTo({left:this.index*this.track.clientWidth,behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth'})}
sync(){const b=this.querySelector('[data-pause]');b.textContent=this.paused?'▶':'Ⅱ';b.setAttribute('aria-label',this.paused?b.dataset.playLabel:b.dataset.pauseLabel)}
disconnectedCallback(){clearInterval(this.timer);this.controller?.abort()}
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shub-centered-header"]) return;
  try {
    
const shubDepartmentSelector = '.shub-top-categories details, .shub-side-menu nav details, .shub-family-nav details';
document.addEventListener('click', (event) => {
  const summary = event.target.closest('summary');
  const current = summary?.parentElement;
  if (current?.matches(shubDepartmentSelector)) {
    document.querySelectorAll(shubDepartmentSelector).forEach((item) => {
      if (item !== current) item.open = false;
    });
  } else if (!event.target.closest('.shub-top-categories, .shub-side-menu, .shub-family-nav')) {
    document.querySelectorAll(shubDepartmentSelector).forEach((item) => { item.open = false; });
  }
});
document.addEventListener('keydown', (event) => {
  if (event.key !== 'Escape') return;
  const opened = Array.from(document.querySelectorAll(shubDepartmentSelector)).find((item) => item.open);
  document.querySelectorAll(shubDepartmentSelector).forEach((item) => { item.open = false; });
  opened?.querySelector('summary')?.focus();
});

document.addEventListener('shopify:cart:lines-update', (event) => {
  event.promise?.then(({cart, detail}) => {
    const count = cart?.totalQuantity ?? detail?.itemCount;
    if (Number.isInteger(count) && count >= 0) {
      document.querySelectorAll('[data-shub-cart-count]').forEach((node) => { node.textContent = String(count); });
    }
  }).catch(() => {});
});

  } catch(e) { console.error(e); }
})();
})();
